export default "__VITE_ASSET__DJx5N$vm__"